// assets
import { IconFileText, IconQrcode, IconReceipt } from '@tabler/icons-react';
import { AUTHORITIES } from 'constants/authorities';

// constant
const icons = { ContactEmergency: IconFileText, QrCode: IconQrcode, PriceChange: IconReceipt };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const billing = {
    id: 'billing',
    title: 'Billing',
    type: 'group',
    authority: AUTHORITIES.BILLING_VIEW,
    children: [
        {
            id: 'contract',
            title: 'Contract',
            type: 'item',
            url: '/billing/contract',
            icon: icons.ContactEmergency
        },
        {
            id: 'promotionCode',
            title: 'Promotion Code',
            type: 'item',
            url: '/billing/promotion',
            icon: icons.QrCode
        },
        {
            id: 'statement',
            title: 'Statement',
            type: 'item',
            url: '/billing/statement',
            icon: icons.PriceChange
        },
        {
            id: 'statement-test',
            title: 'Statement Test',
            type: 'item',
            url: '/billing/statement-test',
            icon: icons.PriceChange
        }
    ]
};

export default billing;
